// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nkl-select {
  width: 75%;
}
.label {
  display: flex;
  justify-content: space-between;
}
.label svg {
  margin-top: 0.2rem;
  margin-right: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nackle/studio-tools/dist/components/icon-selector/icon-selector.less"],"names":[],"mappings":"AAAA;EACI,UAAA;AACJ;AAEA;EACI,aAAA;EACA,8BAAA;AAAJ;AAFA;EAKQ,kBAAA;EACA,oBAAA;AAAR","sourcesContent":[".nkl-select {\n    width: 75%\n}\n\n.label {\n    display: flex;\n    justify-content: space-between;\n\n    svg {\n        margin-top: 0.2rem;\n        margin-right: 0.5rem\n    }\n}\n\n@error-color: #EB0004;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
